export default __webpack_public_path__ + "static/media/workshop1.23362159.JPG";